import { AuthenticatedLayout } from "../../../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { ExportData } from "../../../../components/AddOns/Accounting/ExportData";

export const SynchronizeEmployeesPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Synchronize Employees"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      mainContents={"Comming Soon..."}
    />
  );
};
